import React from "react";
import PropTypes from "prop-types";
import Loadable from "theme/components/helpers/Loadable";
import { compose } from "recompose";
import { FormattedMessage } from "react-intl";

import ProductItem from "theme/modules/ProductView/ProductItem";

const ProductInlineList = (props) => {
  if (props.length === 0) {
    return (
      <p className="product-inline-list--empty">
        <FormattedMessage
          id="modules.ProductList.Inline.empty"
          defaultMessage="Oops... This category is empty"
        />
      </p>
    );
  } else {
    return (
      <div className="product-inline-list">
        {props.products.map(
          (product, index) =>
            props.length > index && (
              <ProductItem
                key={product.sku}
                product={product}
                {...product}
                products={props.products}
                location={props.location}
                index={index}
                itemProp={props.productItemProp}
              />
            )
        )}
      </div>
    );
  }
};

ProductInlineList.propTypes = {
  products: PropTypes.array.isRequired,
  loading: PropTypes.bool,
  length: PropTypes.number.isRequired,
};

const SmartProductInlineList = compose(Loadable((props) => !props.loading))(
  ProductInlineList
);

export default SmartProductInlineList;
